module.exports = __webpack_public_path__ + "static/media/Highland Ave San Carlos, CA4.703ee318.jpg";